import { API_ROUTES } from '../../utils/constants';
import { getClientToken } from '../../utils/helpers';
import fetch from '../../utils/fetch';

export const resetPasswordAPI = (data) => {
  const accessToken = getClientToken().access_token;
  const headers = {

    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = JSON.stringify(data);
  return fetch({
    method: 'POST', route: API_ROUTES.RESET_PASSWORD, requestHeaders: headers, data: formData, basic: false,
  });
};
export const checkTokenAPI = (data) => {
  const accessToken = getClientToken().access_token;
  const headers = {

    'Content-Type': 'application/application/x-www-form-urlencoded',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET',
    route: API_ROUTES.RESET_TOKEN,
    requestHeaders: headers,
    basic: false,
    params: data,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/reset-password/api.js